import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PermissionService } from '@/app/core/services/permission.service';
import { UserService } from '../services/user.service';
import { Observable, of } from 'rxjs';
import { filter, take, switchMap, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CSIGuard implements CanActivate {
    constructor(
        private userService: UserService,
        private permissionService: PermissionService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean> {
        return this.userService.currentUser$.pipe(
            filter((user) => user !== undefined), // wait until we actually know if user exists or not
            take(1),
            switchMap((user) => {
                if (!user?.id) {
                    // Wait until permission$ emits a non-null value
                    this.router.navigateByUrl('/account');
                    return of(false);
                }

                return this.permissionService.permission$.pipe(
                    filter((res) => res?.userPermissions?.length > 0),
                    take(1), // true if permission exists
                    map((permissionsRes) => {
                        const hostname = window.location.hostname;
                        const isDomainValid = hostname.includes('sustainability.doktar') || hostname.includes('localhost') || hostname.includes('staging');
                        const permissions =[...permissionsRes.permissionsByEnterprises, ...permissionsRes.userPermissions];
                        
                        const isCsiAuthorized = permissions.includes('CSIContract_Get');
                        const canActivate = isDomainValid && isCsiAuthorized;
                        
                        if (!canActivate) {
                            this.router.navigateByUrl('/account');
                        }

                        return canActivate;
                    })
                );
            })
        );
    }
}
